import { Flex, HStack, Icon, IconButton, Menu, MenuButton, MenuItem, MenuList, Portal, Text } from '@chakra-ui/react'
import { FaEdit } from 'react-icons/fa'
import { FaDeleteLeft } from 'react-icons/fa6'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from 'src/redux/hooks';
import { openDeleteModal } from 'src/redux/features/question/questionSlice';
import { HamburgerIcon } from '@chakra-ui/icons';

type Props = {
  id: string,
  question_to: string
}

const ActionTable = ({ id, question_to }: Props) => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const handleOpen = () => {
    dispatch(openDeleteModal(id))
  }

  const goToProfile = () => {
    navigate(`/admin/questions/${id}`)
  }

  const goToQstLanguagesPage = () => {
    navigate(`/admin/questions/${id}/languages`)
  }

  return (
    <Flex justifyContent='center' alignItems='center' h='100%' >
      <Menu>
        <MenuButton as={IconButton}
          aria-label='Options'
          icon={<HamburgerIcon />}
          variant='outline'
        />
        <Portal>
          <MenuList>
            <MenuItem>
              <HStack w='100%' color='red.500' cursor='pointer' _hover={{ color: 'red.300' }} onClick={handleOpen} >
                <Icon as={FaDeleteLeft} />
                <Text>Suprimer</Text>
              </HStack>
            </MenuItem>
            <MenuItem >
              <HStack w='100%' color='blue.500' cursor='pointer' _hover={{ color: 'blue.300' }} onClick={goToProfile}>
                <Icon as={FaEdit} />
                <Text>Modifier</Text>
              </HStack>
            </MenuItem>
            {question_to === "patient" && (
              <MenuItem >
                <HStack w='100%' color='blue.500' cursor='pointer' _hover={{ color: 'blue.300' }} onClick={goToQstLanguagesPage}>
                  <Icon as={FaEdit} />
                  <Text>Modifier Les langues</Text>
                </HStack>
              </MenuItem>
            )}
          </MenuList>
        </Portal>
      </Menu>
    </Flex>
  )
}

export default ActionTable